import React, { useEffect, useState } from 'react';
import { Megaphone, Loader2 } from 'lucide-react';
import api from '../../lib/api';

const pct = (a, b) => (b ? `${Math.round((a / b) * 100)}%` : '—');

/** Admin → Group Classes → a class: which invite message brought people in (messaged → opened → saved a seat → joined). */
export function ClassInvitesPanel({ eventId }) {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    let on = true;
    setData(null); setErr(false);
    api.get(`/api/admin/events/${eventId}/invites`).then((r) => { if (on) setData(r.data); }).catch(() => { if (on) setErr(true); });
    return () => { on = false; };
  }, [eventId]);
  if (err) return null;
  if (!data) return <p className="text-[11px] text-slate-400 inline-flex items-center gap-1" data-testid="class-invites-loading"><Loader2 size={11} className="animate-spin" /> Loading invite results…</p>;
  const t = data.totals || {};
  if (!data.journeys?.length) {
    return <p className="text-[11px] text-slate-400" data-testid="class-invites-empty"><Megaphone size={11} className="inline mr-1" />No invite messages went out for this class{t.joined_total ? ` — ${t.joined_total} joined on their own` : ' yet'}. Invite results appear here the moment a journey texts or e-mails students about it.</p>;
  }
  return (
    <div className="border border-indigo-100 rounded-lg bg-indigo-50/40 p-3" data-testid="class-invites-panel">
      <div className="flex items-center justify-between gap-2 mb-2">
        <span className="text-xs font-semibold uppercase tracking-wider text-indigo-900 inline-flex items-center gap-1"><Megaphone size={12} /> Invites → results</span>
        <span className="text-[11px] text-indigo-800" data-testid="class-invites-totals">{t.invited} messaged · {t.joined_invited} of them joined ({pct(t.joined_invited, t.invited)}){t.joined_no_invite ? ` · ${t.joined_no_invite} joined on their own` : ''}</span>
      </div>
      <div className="space-y-1.5">
        {data.journeys.map((j) => (
          <div key={j.journey} className="grid grid-cols-[1fr_auto] gap-x-3 text-xs" data-testid={`class-invite-${j.journey}`}>
            <div className="min-w-0">
              <p className="font-semibold text-slate-800 truncate">{j.label}</p>
              <p className="text-[11px] text-slate-500">{j.sent} messaged{j.emails ? ` · ${j.emails} e-mail${j.emails === 1 ? '' : 's'}` : ''}{j.texts ? ` · ${j.texts} text${j.texts === 1 ? '' : 's'}` : ''}{j.opened ? ` · ${j.opened} opened` : ''}{j.clicked ? ` · ${j.clicked} clicked` : ''}</p>
            </div>
            <div className="text-right whitespace-nowrap">
              {j.journey !== 'class_seat_15m' && <p className="text-slate-700" data-testid={`class-invite-${j.journey}-seats`}><b>{j.seat_saved}</b> saved a seat <span className="text-slate-400">({pct(j.seat_saved, j.sent)})</span></p>}
              <p className="text-emerald-800" data-testid={`class-invite-${j.journey}-joined`}><b>{j.joined}</b> joined <span className="text-slate-400">({pct(j.joined, j.sent)})</span></p>
            </div>
          </div>
        ))}
      </div>
      <p className="text-[11px] text-slate-400 mt-2">Who came from where: open <b>Attendance &amp; grants</b> — every row shows the message(s) that reached that student.</p>
    </div>
  );
}
